import { Component } from '@angular/core';

@Component({
  selector: 'sales-information-header-bar',
  templateUrl: './information-header-bar.component.html',
  styleUrls: ['./information-header-bar.component.scss'],
})
export class InformationHeaderBarComponent {}
